'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _Works = require('./Works.css');

var _Works2 = _interopRequireDefault(_Works);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Works = (_dec = (0, _reactCssModules2.default)(_Works2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Works, _Component);

  function Works(props) {
    (0, _classCallCheck3.default)(this, Works);
    return (0, _possibleConstructorReturn3.default)(this, (Works.__proto__ || (0, _getPrototypeOf2.default)(Works)).call(this, props));
  }

  (0, _createClass3.default)(Works, [{
    key: 'render',
    value: function render() {
      var iconOne = require('../../../static/images/icons_step1_blue.svg');
      var iconTwo = require('../../../static/images/icons_step2_blue.svg');
      var iconThree = require('../../../static/images/icons_step3_blue.svg');
      var iconFour = require('../../../static/images/icons_step4_blue.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'works-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'works' },
          _react2.default.createElement(
            'div',
            { styleName: 'works-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'works-title' },
              'How to make your investments align with your values'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'works-steps-photos' },
              _react2.default.createElement(
                'div',
                { styleName: 'works-steps' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-step' },
                  _react2.default.createElement('img', {
                    styleName: 'works-step-img',
                    alt: 'Step one icon',
                    src: iconOne
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-title' },
                    '1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-info' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'white' },
                      _react2.default.createElement(
                        _.Link,
                        {
                          to: _config2.default.routes.clean,
                          title: 'Search funds | ' + _config2.default.app.title,
                          strong: true
                        },
                        'Search for mutual funds and exchange-traded funds (ETFs)'
                      )
                    ),
                    ' by name, ticker, or asset manager. Our database covers 3,000 stock funds available in the U.S.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-step' },
                  _react2.default.createElement('img', {
                    styleName: 'works-step-img',
                    alt: 'Step two icon',
                    src: iconFour
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-title' },
                    '2'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-info' },
                    'See your results. For each fund, we scan which companies the fund invests in, and calculate a fund gender equality score. Then, we rank funds against others with a similar investment profile, and apply a gender equality grade based on those group rankings.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-step' },
                  _react2.default.createElement('img', {
                    styleName: 'works-step-img',
                    alt: 'Step three icon',
                    src: iconTwo
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-title' },
                    '3'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-info' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'white' },
                      _react2.default.createElement(
                        _.Link,
                        {
                          to: _config2.default.routes.clean,
                          title: 'Search funds | ' + _config2.default.app.title,
                          strong: true
                        },
                        'Look for options that align with your values.'
                      )
                    ),
                    ' Sort and compare to find funds that fit your investing needs.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'works-step' },
                  _react2.default.createElement('img', {
                    styleName: 'works-step-img',
                    alt: 'Step four icon',
                    src: iconThree
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-title' },
                    '4'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'works-step-info' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'white' },
                      _react2.default.createElement(
                        _.Link,
                        {
                          to: _config2.default.routes.toolkit,
                          title: 'Action toolkit | ' + _config2.default.app.title,
                          strong: true
                        },
                        'Talk to your financial advisor or retirement plan manager'
                      )
                    ),
                    ' about gender-lens investing.'
                  )
                )
              ),
              _react2.default.createElement('div', {
                styleName: 'works-photo',
                title: 'How to make your investments match your values'
              })
            )
          )
        )
      );
    }
  }]);
  return Works;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = Works;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Works/Works.js
// module id = 1299
// module chunks = 0